module.exports = __webpack_public_path__ + "img/incub-mobil.c8c7adb4.svg";